import { Avatar, AvatarFallback, AvatarImage } from "@/components/radix/avatar";
import React from "react";
import { TriggerProps } from "./types";

export const DesktopTrigger = React.forwardRef<
	HTMLButtonElement,
	TriggerProps & React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ user, getInitials, getAvatarUrl, ...props }, ref) => {
	// Get first name for display
	const firstName = (user.name || "User").split(" ")[0];

	return (
		<button
			ref={ref}
			type="button"
			className="btn-clickable flex items-center gap-2 hover:bg-gray-50 transition-colors rounded-md h-10 px-3 py-2 bg-transparent border border-gray-200 hover:border-gray-300 w-[120px]"
			{...props}
		>
			<Avatar size="sm" className="ring-2 ring-primary/20 w-6 h-6">
				<AvatarImage src={getAvatarUrl(user)} alt={user.name} />
				<AvatarFallback className="bg-primary text-primary-foreground text-xs font-semibold">
					{getInitials(user.name)}
				</AvatarFallback>
			</Avatar>
			{/* Show first name on large screens only with fixed width and ellipsis */}
			<span className="hidden lg:block text-sm font-medium text-gray-700 truncate flex-1 text-left">{firstName}</span>
		</button>
	);
});

DesktopTrigger.displayName = "DesktopTrigger";
